import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgDashboard = function SvgDashboard(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("rect", {
    width: 11,
    height: 9,
    y: 2,
    fill: "currentColor",
    rx: 1.5
  }), React.createElement("rect", {
    width: 11,
    height: 9,
    x: 13,
    y: 2,
    fill: "currentColor",
    rx: 1.5
  }), React.createElement("rect", {
    width: 11,
    height: 9,
    y: 13,
    fill: "currentColor",
    rx: 1.5
  }), React.createElement("rect", {
    width: 11,
    height: 9,
    x: 13,
    y: 13,
    fill: "currentColor",
    rx: 1.5
  }));
};

export default SvgDashboard;